import * as cartApi from '../../helpers/cartApi';

const selectors = {
  quantityIncrement: '[data-quantity-increment]',
  quantityDecrement: '[data-quantity-decrement]',
  quantityInput: '[data-quantity-input]',
  removeItemButton: '[data-cart-remove]',
  itemError: '[data-item-error]',
};

/**
 * The wrapper class for Cart items
 *
 * @export
 * @class CartItem
 */
export default class CartItem {
  constructor(el, updateCart) {
    this.el = el;
    this.updateCart = updateCart;

    this._init();
  }

  _init = () => {
    this.quantityIncrement = this.el.querySelector(selectors.quantityIncrement);
    this.quantityDecrement = this.el.querySelector(selectors.quantityDecrement);
    this.quantityInput = this.el.querySelector(selectors.quantityInput);
    this.removeItemButton = this.el.querySelector(selectors.removeItemButton);
    this.itemError = this.el.querySelector(selectors.itemError);

    this._attachListeners();
  };

  _attachListeners = () => {
    this.quantityIncrement.addEventListener('click', this.incrementQuantity);
    this.quantityDecrement.addEventListener('click', this.decrementQuantity);
    this.quantityInput.addEventListener('input', this.updateQuantity);
    this.removeItemButton.addEventListener('click', this.removeItem);
  };

  incrementQuantity = () => {
    const line = this.el.dataset.cartItem;
    const newQuantity = parseInt(this.quantityInput.value) + 1;
    this.changeAndUpdate(line, newQuantity);
  };

  decrementQuantity = () => {
    const line = this.el.dataset.cartItem;
    const newQuantity = parseInt(this.quantityInput.value) - 1;
    this.changeAndUpdate(line, newQuantity);
  };

  updateQuantity = () => {
    const line = this.el.dataset.cartItem;
    const newQuantity = this.quantityInput.value;
    this.changeAndUpdate(line, newQuantity);
  };

  removeItem = () => {
    const line = this.el.dataset.cartItem;
    this.changeAndUpdate(line, 0);
  };

  showErrorMessage = message => {
    this.itemError.textContent = message;
  };

  resetQuantityInput = () => {
    const maxQuantity = parseInt(this.quantityInput.max);
    this.quantityInput.value = maxQuantity;
  };

  changeAndUpdate = (line, quantity) => {
    cartApi.change({ line, quantity }).then(res => {
      if (res.sections && !res.error) {
        this.updateCart({ sections: res.sections });
      } else {
        this.showErrorMessage(res.message);
        this.resetQuantityInput();
      }
    });
  };
}
